import SolutionCard from "../../reusables/SolutionCard";
import ecomm from "../../../assets/images/solutions-icon/ecommerce-website-icon.svg";

const EcommerceSolution = () => {
  return (
    <SolutionCard
      icon={ecomm}
      title="E-commerce Solutions"
      subtitle="Online stores with payment integration and seamless user experience"
      ctaLink="/solutions/ecommerce"
    />
  );
};
 
export default EcommerceSolution;